{
	"title": "Chats",
	"newChat": "New chat",
	"messageActions": {
		"label": "Reply actions",
		"flashcards": "Open flashcards",
		"quiz": "Open quiz",
		"material": "Open material",
		"planSubsection": "Open in plan",
		"note": "Open note",
		"plan": "Open study plan",
		"collection": "Open folder",
		"saveToArtifacts": "Save to artifacts",
		"savedTooltip": "Already in artifacts",
		"savingTitle": "Saving…",
		"saveSuccess": "Saved to artifacts",
		"saveOpen": "Open",
		"saveFailed": "Could not save the answer"
	},
	"chatList": {
		"title": "History",
		"empty": "No chats"
	},
	"modes": {
		"regular": "Regular",
		"regularDescription": "General AI chat",
		"materials": "From materials",
		"materialsDescription": "Answers based on your materials",
		"webSearch": "Web search",
		"webSearchDescription": "With up-to-date data from the web"
	},
	"modeChange": {
		"title": "Switch mode?",
		"hint": "Switching mode will affect future answers. History will be preserved.",
		"cancel": "Cancel",
		"confirm": "Switch"
	},
	"sessions": {
		"subtitle": "{count} chats · {used}/{limit}k tokens",
		"scenarios": "Scenarios",
		"skills": "Skills",
		"searchPlaceholder": "Search chats...",
		"messageCount": "{count} msgs",
		"noPreview": "No messages",
		"untitled": "Untitled",
		"dateGroups": {
			"today": "Today",
			"yesterday": "Yesterday",
			"week": "This week",
			"older": "Earlier"
		},
		"filters": {
			"all": "All"
		},
		"menu": {
			"label": "Chat actions",
			"rename": "Rename",
			"export": "Export"
		},
		"empty": {
			"title": "Your chats will appear here",
			"hint": "AI knows your materials — ask anything about notes, lectures or topics.",
			"start": "Start a chat",
			"todayPlan": "What should I study today?",
			"todayPlanPrompt": "What should I study today? Build a personal plan based on my materials, reviews, and study plan."
		},
		"emptyFilter": {
			"title": "Nothing matches your filters",
			"hint": "Reset filters or try a different query"
		},
		"error": {
			"title": "Couldn't load chats",
			"retry": "Retry"
		},
		"subtitleNoLimit": "{count} chats"
	},
	"chat": {
		"back": "Back",
		"settings": "Chat settings",
		"scrollToBottom": "Scroll to bottom",
		"actions": {
			"rename": "Rename",
			"export": "Export",
			"delete": "Delete",
			"menu": "Chat actions",
			"renameSuccess": "Chat renamed",
			"renameError": "Couldn't rename",
			"renameTitle": "Rename chat",
			"renameDesc": "The new title will appear in the chat list.",
			"renamePlaceholder": "Chat title",
			"exportEmpty": "This chat has no messages yet",
			"deleteSuccess": "Chat deleted",
			"deleteError": "Couldn't delete the chat",
			"deleteTitle": "Delete chat?",
			"deleteDesc": "The chat will move to trash for 30 days."
		},
		"empty": {
			"title": "Start a conversation",
			"hint": "Pick a mode above and ask your first question. AI knows your materials.",
			"starters": {
				"explain": "Explain a topic in simple terms — say which one",
				"compare": "Compare two approaches",
				"solve": "Help me solve a problem"
			},
			"startersMaterials": {
				"mainIdea": {
					"label": "Explain the main idea",
					"prompt": "Explain the main idea of this material in plain language."
				},
				"summary": {
					"label": "Summary",
					"prompt": "Summarise this material in 5 sentences."
				},
				"keyTerms": {
					"label": "Key terms",
					"prompt": "List the key terms from this material and briefly explain each."
				},
				"remember": {
					"label": "What to remember",
					"prompt": "What is most important to remember in this material? Highlight the key points."
				}
			},
			"todayPlan": "What should I study today?",
			"todayPlanPrompt": "What should I study today? Build a personal plan based on my materials, reviews, and study plan."
		},
		"followUp": {
			"groupLabel": "Suggestions",
			"explainSimpler": {
				"label": "Explain simpler",
				"prompt": "Explain the previous answer simpler, like for a school student.",
				"promptMaterials": "Explain the main idea of this material more simply, like for a school student. Ground the answer in the sources."
			},
			"examples": {
				"label": "Give examples",
				"prompt": "Give a few concrete examples for the previous answer.",
				"promptMaterials": "Give a few concrete examples from this material for the key ideas."
			},
			"goDeeper": {
				"label": "Go deeper",
				"prompt": "Go deeper into the previous answer: key nuances and connections.",
				"promptMaterials": "Go deeper into this material: key nuances and connections. Ground the answer in the sources."
			}
		},
		"error": {
			"title": "Couldn't get an answer",
			"retry": "Retry",
			"regenerate": "Failed to regenerate the answer",
			"editMessage": "Failed to save the edit",
			"deleteMessage": "Failed to delete the message",
			"createSession": "Couldn't create the chat. Please try again.",
			"updateMode": "Couldn't switch mode",
			"updateScenario": "Couldn't update the scenario",
			"updateSkills": "Couldn't update skills"
		},
		"export": {
			"user": "User",
			"assistant": "Tutor"
		},
		"autoExplainTopic": "Explain the topic: \"{topic}\". Where am I going wrong and what should I pay attention to?",
		"offlineWrite": "You're offline — sending and create actions need a connection.",
		"offlineAttachments": "Attachments can't be sent offline",
		"streamBusy": "Wait for the reply to finish, then confirm the action."
	},
	"terminal": {
		"length": {
			"banner": "The response was cut off due to length limits.",
			"continue": "Continue",
			"continuePrompt": "Continue from where you left off."
		},
		"toolLimit": {
			"banner": "Couldn't finish the tool chain",
			"hint": "Try rephrasing your request or try again.",
			"retry": "Try again",
			"rephrase": "Rephrase",
			"retryPrompt": "Please try again with the same request.",
			"rephrasePrompt": "Please rephrase your request more specifically."
		}
	},
	"stream": {
		"queued": "Queued...",
		"retrieving": "Searching your materials...",
		"found": "Found {chunks} fragments from {sources} materials",
		"generating": "Generating answer...",
		"toolCallingStudyState": "Checking your study state...",
		"toolCallingPlan": "Checking your study plan...",
		"toolCallingCreateArtifact": "Creating study material...",
		"toolCallingDefault": "Working on it...",
		"toolCalling": {
			"study_state": "Checking your study state...",
			"plan_tasks": "Checking your study plan...",
			"get_study_plans": "Loading your study plans...",
			"create_artifact": "Creating study material...",
			"create_plan": "Building a study plan...",
			"manage_plan": "Updating your study plan...",
			"get_collections": "Loading folders...",
			"manage_collection": "Updating folder...",
			"generate_from_collection": "Generating from folder...",
			"search_library": "Searching your library...",
			"add_material": "Adding material...",
			"retry_material": "Retrying material processing...",
			"generate_audio_recap": "Starting audio recap...",
			"start_essay": "Creating essay draft...",
			"submit_essay": "Submitting essay...",
			"open_voice": "Preparing Voice Tutor...",
			"open_audio": "Preparing audio recap...",
			"practice_weak_spot": "Setting up weak-spot practice...",
			"export_glossary": "Exporting glossary to flashcards...",
			"regenerate_note": "Regenerating note...",
			"note_ai_block": "Working on note AI block...",
			"progress_snapshot": "Checking your progress...",
			"manage_calendar": "Updating calendar...",
			"streak_state": "Checking your streak...",
			"use_streak_freeze": "Preparing streak freeze...",
			"notes_catalog": "Looking up notes...",
			"quiz_catalog": "Looking up quizzes...",
			"recordings_catalog": "Looking up recordings...",
			"topic_context": "Reading topic materials...",
			"open_flashcard_study": "Opening flashcard study...",
			"open_quiz_take": "Opening quiz...",
			"undo_last_action": "Undoing…"
		},
		"cancelled": "(stopped)",
		"noContext": "No relevant context found in your materials — answering without them",
		"webSearchSkipped": "Web search was not needed — answering from model knowledge",
		"errorTitle": "Couldn't get an answer",
		"circuitOpenTitle": "AI temporarily unavailable",
		"awaitingPersist": "Answer is still being prepared…",
		"retryAfterSeconds": "try again in {seconds} s",
		"retryable": "can retry",
		"errorHint": "Chat isn’t ready yet. Wait a moment and try again.",
		"retrievalPlain": "Searching your materials...",
		"retrievalQuery": "Searching for:",
		"retrievalContinuation": "Continuing the topic, looking for something new:",
		"retrievalReveal": "Show the full search query",
		"searched": "Searched for:",
		"searchedContinuation": "Continued the topic:",
		"searchedExpand": "Show the full search query",
		"searchedCollapse": "Collapse the search query"
	},
	"thoughts": {
		"live": "Thinking… · {count, plural, one {# step} other {# steps}}",
		"summary": "Thought for {seconds}s · {count, plural, one {# step} other {# steps}}",
		"summaryNoTime": "Reasoning · {count, plural, one {# step} other {# steps}}",
		"toggleAria": "Reasoning steps",
		"show": "Show reasoning",
		"hide": "Hide reasoning",
		"step": {
			"read": "Read:",
			"readMore": "+{count, plural, one {# more} other {# more}}",
			"noContext": "Answering from general knowledge",
			"searched": "Searched:",
			"webSearch": "Web search:"
		}
	},
	"webSearch": {
		"searching": "Searching the web: \"{query}\"",
		"found": "Sources: {count}",
		"loading": "Loading sources..."
	},
	"composer": {
		"placeholder": "Ask anything…",
		"placeholderMaterial": "Ask about this material…",
		"placeholderWeb": "Search the web for fresh data...",
		"send": "Send",
		"stop": "Stop",
		"stopVoice": "Stop",
		"startVoice": "Start voice",
		"startVoiceHint": "Start voice session",
		"voiceInput": "Voice input",
		"recording": "Recording... (tap to stop)",
		"transcribing": "Transcribing…",
		"sttPermissionDenied": "Microphone access denied",
		"sttNotSupported": "Voice input is not supported in this browser",
		"sttEmpty": "Empty recording — please try again",
		"sttFailed": "Could not transcribe speech",
		"sttNoSpeech": "Couldn't catch any speech",
		"attach": "Attach",
		"tools": "Attach and configure",
		"attachMaterial": "Attach material",
		"modifiers": "Scenarios and skills",
		"image": "Image",
		"file": "File",
		"material": "Material",
		"searchMaterials": "Find material...",
		"noMaterials": "No results",
		"hint": "Enter to send · Shift+Enter for newline",
		"quotaExceeded": "Quota exhausted — upgrade plan",
		"materialAttached": "Material attached: {name}",
		"materialAttachFailed": "Couldn't attach the material",
		"attachTooLarge": "File is larger than 20 MB — try a smaller one",
		"attachTooLargeTier": "File is too large for your plan (Free allows up to 10 MB)",
		"attachTooMany": "You can attach at most {max} files",
		"attachUnsupported": "This file type is not supported",
		"attachUploadFailed": "Couldn't upload the file",
		"attachUploading": "Uploading…",
		"attachError": "Upload error",
		"attachRemove": "Remove",
		"dropToAttach": "Drop to attach to your message",
		"dropFormats": "Images, PDF, Word, Excel, text",
		"modifiersLoading": "Loading…",
		"modifiersEmptyScenarios": "No scenarios — create the first one",
		"modifiersEmptySkills": "No skills — create the first one",
		"modifiersClear": "Clear",
		"modifiersManage": "Manage",
		"attachTooLargeLimit": "File is too large to attach",
		"quotaExceededNoSale": "Message limit reached for today"
	},
	"voiceInline": {
		"listening": "Listening…",
		"speaking": "Speaking…",
		"thinking": "Thinking…",
		"connecting": "Connecting…",
		"searching": "Searching materials…",
		"micMuted": "Mic off",
		"end": "End voice",
		"muteMic": "Mute microphone",
		"muteSpeaker": "Mute speaker",
		"endedContinueText": "Voice ended — continue in text",
		"goAway": "Voice session ending — continue in text",
		"typeIntoLive": "Type into live…",
		"needSession": "Open a chat or send a message first to start voice",
		"startFailed": "Could not start voice mode",
		"micHeldHint": "Mic turns on after the greeting"
	},
	"message": {
		"you": "You",
		"tutor": "Tutor",
		"thinking": "Thinking…",
		"regenerate": "Regenerate",
		"copy": "Copy",
		"copied": "Copied",
		"copiedToClipboard": "Message copied to clipboard",
		"copyFailed": "Couldn't copy",
		"feedback": {
			"good": "Helpful",
			"bad": "Inaccurate",
			"failed": "Failed to submit rating"
		},
		"menu": {
			"convertToNote": "Convert to note",
			"createFlashcards": "Create flashcards",
			"share": "Share",
			"more": "More actions"
		},
		"sources": "Sources",
		"sourceFromMaterial": "From material \"{name}\"",
		"webSourceLabel": "From the web",
		"shareCopied": "Answer text copied",
		"shareFailed": "Failed to copy",
		"speak": "Speak",
		"stopSpeaking": "Stop speaking",
		"ttsPlaybackRate": "Playback speed {rate}",
		"downloadAudio": "Download audio",
		"ttsPreparing": "Preparing audio…",
		"ttsEmpty": "Nothing to speak",
		"ttsQuota": "Speech quota exceeded",
		"ttsFailed": "Could not speak this answer",
		"ttsDownloadFailed": "Could not download audio",
		"ttsPartial": "Only the first part of the answer was spoken",
		"ttsOffline": "You are offline",
		"ttsMediaTitle": "Tutor answer"
	},
	"citations": {
		"groupAria": "{count, plural, one {# source: {name}} other {# sources: {name}}}"
	},
	"citationSheet": {
		"webHeader": "Web source",
		"lectureHeader": "Lecture recording",
		"materialHeader": "From material",
		"page": "p. {n}",
		"openWeb": "Open in new tab",
		"openMaterial": "Open material",
		"jumpAudio": "Jump to timestamp",
		"jumpAudioAt": "Open recording at {time}",
		"materialFallback": "material"
	},
	"voiceMode": {
		"title": "Voice mode",
		"start": "Start conversation",
		"stop": "End",
		"listening": "Listening…",
		"speaking": "Speaking…",
		"muted": "Microphone is off",
		"mute": "Mute",
		"unmute": "Unmute",
		"audioWarning": "Audio is not stored"
	},
	"scenariosPage": {
		"title": "Scenarios",
		"subtitle": "Pre-built system prompts for different dialogue styles",
		"create": "Create",
		"search": "Search...",
		"builtin": "Built-in ({n})",
		"mine": "Mine ({n})",
		"filters": {
			"all": "All",
			"builtin": "Built-in",
			"mine": "Mine"
		},
		"empty": {
			"title": "Create your scenario",
			"hint": "Describe a dialogue style with one system prompt and reuse it across chats.",
			"cta": "Create"
		}
	},
	"scenarios": {
		"launch": "Launch",
		"launchHint": "Start a new chat with this scenario",
		"start": "Start chat",
		"builtinBadge": "Built-in",
		"edit": "Edit",
		"delete": "Delete",
		"dialog": {
			"createTitle": "New scenario",
			"editTitle": "Edit scenario",
			"subtitle": "A scenario sets the system prompt — the style and tone of dialogue for every chat using it.",
			"name": "Name",
			"namePlaceholder": "e.g. Socratic dialogue",
			"description": "Description",
			"descriptionPlaceholder": "A short note for yourself",
			"prompt": "System prompt",
			"promptPlaceholder": "Describe the AI's answer style — this instruction applies to every message.",
			"promptHint": "Minimum 10 characters, maximum 8000. Markdown is supported."
		},
		"toast": {
			"updated": "Scenario updated",
			"created": "Scenario created",
			"saveFailed": "Couldn't save",
			"deleted": "Scenario deleted",
			"deleteFailed": "Couldn't delete"
		},
		"deleteConfirm": {
			"title": "Delete scenario?",
			"body": "\"{name}\" will move to trash for 30 days. Existing chats using this scenario will keep working without it."
		}
	},
	"skillsPage": {
		"title": "Skills",
		"subtitle": "A library of skills — short instructions that shape the answer style. Enable them in any chat via the modifiers button (✦) next to the input.",
		"create": "Create",
		"search": "Search...",
		"builtin": "Built-in",
		"mine": "Mine",
		"empty": {
			"title": "Create your skill",
			"hint": "A short instruction you can enable in any tutor chat.",
			"cta": "Create"
		}
	},
	"skills": {
		"title": "Skills",
		"explain": "Explain",
		"quiz": "Quiz me",
		"summarize": "Summarize",
		"rephrase": "Rephrase",
		"builtinBadge": "Built-in",
		"edit": "Edit",
		"delete": "Delete",
		"dialog": {
			"createTitle": "New skill",
			"editTitle": "Edit skill",
			"subtitle": "A short instruction that is added to the AI prompt when the skill is active.",
			"name": "Name",
			"namePlaceholder": "e.g. LaTeX formulas",
			"description": "Description",
			"descriptionPlaceholder": "A short note for yourself",
			"instruction": "Instruction",
			"instructionPlaceholder": "e.g. \"Wrap every formula in $$…$$ to render LaTeX\".",
			"instructionHint": "Minimum 5 characters, maximum 2000."
		},
		"toast": {
			"updated": "Skill updated",
			"created": "Skill created",
			"saveFailed": "Couldn't save",
			"deleted": "Skill deleted",
			"deleteFailed": "Couldn't delete"
		},
		"deleteConfirm": {
			"title": "Delete skill?",
			"body": "\"{name}\" will move to trash for 30 days."
		}
	},
	"panel": {
		"title": "Tutor",
		"greetingTitle": "Hi, I am StudyHub Tutor",
		"greetingHint": "Ask something about your topic or pick a suggestion below.",
		"placeholder": "Ask about a topic…",
		"clear": "Clear chat",
		"close": "Close panel",
		"hint": "Enter to send · Shift+Enter for newline",
		"thinking": "Thinking…",
		"sessionFailed": "Failed to start a session. Please try again.",
		"answerFailed": "Failed to get an answer. Please try again.",
		"newChat": "New chat",
		"history": "Chat history",
		"historyShort": "History",
		"historyTitle": "Chat history",
		"settings": "Panel settings",
		"back": "Back",
		"deleteConfirm": "The chat will move to trash for 30 days.",
		"deleted": "Chat deleted",
		"renamed": "Chat renamed",
		"ariaLabel": "AI tutor",
		"sg": {
			"visual": "Create a visualization to help me understand this topic",
			"context": "Give me an introduction to the topic",
			"hint": "Give me a hint without the direct answer",
			"todayPlan": "What should I study today?"
		},
		"course": {
			"build": {
				"label": "Build the program",
				"prompt": "Draft a program for the course “{topic}”: split it into topics and explain the order."
			},
			"refine": {
				"label": "Refine the program",
				"prompt": "Look at the draft program of “{topic}” and propose concrete edits — what to reorder, merge or reword. One change at a time, and say why."
			},
			"add": {
				"label": "What is missing?",
				"prompt": "What is missing from the course “{topic}”? Propose adding the missing topics, one at a time, and say why each matters."
			},
			"trim": {
				"label": "Drop what is extra",
				"prompt": "My goal is “{goal}”. Which topics of “{topic}” can be dropped without hurting it? Propose removing them one at a time."
			},
			"sources": {
				"label": "Find sources",
				"prompt": "Find two or three solid sources on “{topic}” on the web and propose adding the best ones to the course."
			}
		}
	},
	"context": {
		"material": "Chat on material “{name}”",
		"materialPlus": "Chat on material “{name}” +{count}",
		"materialsCount": "Chat on {count, plural, one {# material} other {# materials}}",
		"collection": "Chat on folder “{name}”",
		"collectionPlus": "Chat on folder “{name}” +{count}",
		"collectionsCount": "Chat on {count, plural, one {# folder} other {# folders}}",
		"label": "Context",
		"remove": "Remove from context",
		"pending": "“{name}” will be added",
		"dismissPending": "Don’t add",
		"focusQuestion": "Question {n}/{total}",
		"focusCard": "Card {n}/{total}",
		"kind": {
			"material": "Material",
			"collection": "Folder",
			"recap": "Audio recap",
			"essay": "Essay",
			"visual": "Photo explanation",
			"recording": "Recording",
			"voice": "Voice session"
		}
	},
	"materials": {
		"scope": {
			"title": "Choose materials",
			"description": "AI will look for answers only in the selected materials. With no selection, it searches all materials.",
			"useAll": "All materials",
			"apply": "Apply"
		},
		"chip": {
			"allMaterials": "All materials",
			"choose": "Choose",
			"materialsCount": "{count, plural, one {# material} other {# materials}}"
		}
	},
	"artifactCard": {
		"pending": "Creating {artifact}…",
		"ready": "{artifact} ready",
		"failed": "Couldn't create",
		"open": "Open",
		"retry": "Retry",
		"quizSummary": "{count, plural, one {# question} other {# questions}}",
		"flashcardsSummary": "{count, plural, one {# card} other {# cards}}",
		"glossarySummary": "{count, plural, one {# term} other {# terms}}"
	},
	"chatArtifact": {
		"untitled": "Artifact",
		"openLarge": "Open large",
		"openLargeOf": "Open “{title}” at full size",
		"generating": "Infographic is being prepared…",
		"failed": "Couldn't create it",
		"retry": "Try again",
		"retryFailed": "Couldn't start it again. Please try later.",
		"retryPrompt": "Rebuild the infographic: {title}",
		"emptyDiagram": "The reply had no diagram",
		"urlFailed": "Couldn't load the image"
	},
	"artifactViewer": {
		"untitled": "Artifact",
		"kind": {
			"diagram": "Diagram",
			"infographic": "Infographic"
		},
		"generatingTitle": "Still being prepared",
		"generatingHint": "It will open here as soon as it is ready.",
		"failedTitle": "Couldn't create it",
		"failedHint": "Try again from the artifacts panel.",
		"emptyDiagram": "The diagram source is empty",
		"urlFailedTitle": "Couldn't open the file",
		"urlFailedHint": "The link may have expired — request a new one.",
		"retry": "Try again",
		"download": "Download",
		"downloadFailed": "Couldn't download the file"
	},
	"richCard": {
		"pending": "In progress…",
		"ready": "Ready",
		"failed": "Couldn't complete",
		"open": "Open",
		"undo": "Undo",
		"confirm": {
			"title": "Confirm action",
			"hint": "This change can't be undone easily.",
			"cta": "Confirm",
			"cancel": "Cancel",
			"failed": "Couldn't confirm the action. Try again."
		},
		"undoFailed": "Couldn't undo the action.",
		"machinePrompt": {
			"confirm": "Action confirmation",
			"undo": "Action undo"
		},
		"kinds": {
			"artifact": "Study material",
			"plan": "Study plan",
			"collection": "Folder",
			"material": "Material",
			"action_result": "Result",
			"confirm": "Confirmation",
			"progress_summary": "Progress",
			"weak_spot": "Weak spot",
			"calendar_event": "Event",
			"essay": "Essay",
			"audio_recap": "Audio recap",
			"recording": "Recording",
			"visual": "Visual"
		}
	},
	"createFrom": {
		"title": "Create from chat",
		"menuTitle": "Create from chat",
		"notes": "Note",
		"flashcards": "Flashcards",
		"quiz": "Quiz",
		"glossary": "Glossary",
		"voice": "Voice session",
		"audio": "Audio recap",
		"configureNote": "Configure note…",
		"configureFlashcards": "Configure flashcards…",
		"configureQuiz": "Configure quiz…",
		"generating": "{artifact} · generating…",
		"started": "{artifact} is being created — you'll get a notification",
		"readyTitle": "{artifact} ready",
		"readyOpen": "Open",
		"failed": "Couldn't create {artifact}. Please try again.",
		"busy": "An artifact is already being created from this chat — wait until it finishes.",
		"disabledHint": "Ask the tutor a question to create study materials",
		"materializing": "Preparing material from the chat…",
		"materializeFailed": "Couldn't prepare material from the chat",
		"options": {
			"noteTitle": "Note settings",
			"noteDesc": "Level of detail for the note from this chat.",
			"detailLevel": "Detail level",
			"detailSummarized": "Summarized",
			"detailInDepth": "In-depth",
			"detailComprehensive": "Comprehensive",
			"flashcardsTitle": "Flashcards settings",
			"flashcardsDesc": "How many flashcards to create from this chat.",
			"flashcardsCount": "Number of cards",
			"quizTitle": "Quiz settings",
			"quizDesc": "Quiz parameters for this chat.",
			"quizCount": "Number of questions",
			"quizDifficulty": "Difficulty",
			"difficultyEasy": "Easy",
			"difficultyMedium": "Medium",
			"difficultyHard": "Hard",
			"difficultyMixed": "Mixed",
			"create": "Create",
			"cancel": "Cancel"
		}
	},
	"assets": {
		"imageAlt": "Figure from the material",
		"openImage": "Open figure"
	},
	"outbox": {
		"dropped": "{count, plural, one {# message was not sent} other {# messages were not sent}}",
		"droppedCopy": "Copy text"
	},
	"failedTurn": {
		"hint": "We tried several times and never got an answer. Your message is saved — you can try again.",
		"retry": "Try again"
	},
	"intro": {
		"title": "The tutor answers and builds",
		"body": "It reads your materials and on request assembles a note, cards, a test or a diagram right here — creating them, not describing them.",
		"bullets": [
			"Answers from your sources and cites the fragments",
			"Searches the web when your materials have no answer",
			"Draws diagrams and infographics inside the chat"
		]
	}
}
